<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    fill="currentColor"
    viewBox="0 0 500 500"
    xml:space="preserve"
  >
    <g>
      <path
        d="M152.5,124.5c-30.6,0-55.5,24.9-55.5,55.5c0,13,4.6,25.7,13,35.7l40.4,48.1c1.8,2.1,5.3,2.1,7.1,0l40.4-48.1
		c8.4-10,13-22.7,13-35.7c0-30.6-24.9-55.5-55.5-55.5H152.5z M153.9,273.7c-3.8,0-7.4-1.7-9.9-4.6L103.7,221c-9.6-11.5-15-26-15-41
		c0-35.2,28.6-63.8,63.8-63.8h2.8c35.2,0,63.8,28.6,63.8,63.8c0,15-5.3,29.6-15,41l-40.4,48.1C161.3,272,157.7,273.7,153.9,273.7"
      />
      <path
        d="M153.9,149.3c-16.9,0-30.7,13.8-30.7,30.7c0,16.9,13.8,30.7,30.7,30.7s30.7-13.8,30.7-30.7
		C184.6,163.1,170.8,149.3,153.9,149.3 M153.9,218.9c-21.5,0-39-17.5-39-39c0-21.5,17.5-39,39-39s39,17.5,39,39
		C192.9,201.5,175.4,218.9,153.9,218.9"
      />
      <path
        d="M345.5,356.1H220.7c-13.4,0-24.4-10.9-24.4-24.4v-1.5c0-13.4,10.9-24.4,24.4-24.4h6.1
		c8.9,0,16.1-7.2,16.1-16.1c0-8.9-7.2-16.1-16.1-16.1h-72.9c-2.3,0-4.1-1.9-4.1-4.1c0-2.3,1.8-4.1,4.1-4.1h72.9
		c13.4,0,24.4,10.9,24.4,24.4c0,13.4-10.9,24.4-24.4,24.4h-6.1c-8.9,0-16.1,7.2-16.1,16.1v1.5c0,8.9,7.2,16.1,16.1,16.1h124.7
		c2.3,0,4.1,1.8,4.1,4.1S347.7,356.1,345.5,356.1"
      />
      <path
        d="M389.4,376.7h10.1l-17.1-25.5l16.3-24.2H389l-11.8,18.6l-11.7-18.6h-10.1l16.3,24.3l-17,25.3h9.6l12.6-19.7
		L389.4,376.7z M411.5,383.1h-25.6l-9-14.1l-9,14.1h-25.3l21.4-31.7l-20.6-30.8h25.6l8.2,13l8.2-13h25.3l-20.6,30.6L411.5,383.1z"
      />
    </g>
  </svg>
</template>
